import { FileManager } from 'utils/file-manager';
import { setAssetsFolder } from 'redux/modules/user/blogger/bloggerSlice';
import { StoreType } from '../redux/store';

export async function assetFolderLoader(params: { '*': string }, store: StoreType) {
  const selectedPath = params['*'] as string;
  console.log('loader: ', selectedPath);
  if (FileManager.getEditorType(selectedPath) === 'posts') {
    store.dispatch(setAssetsFolder({
      post: selectedPath
    }))
  } else if (selectedPath.endsWith('.md.meta.json')) {
    store.dispatch(setAssetsFolder({
      post: selectedPath.substring(0, selectedPath.length - '.meta.json'.length)
    }))
  } else if (selectedPath.endsWith('/meta.json')) {
    store.dispatch(setAssetsFolder({
      post: selectedPath.substring(0, selectedPath.length - 'meta.json'.length)
    }))
  } else {
    const pathParts = selectedPath.split('/');
    const assetPart = pathParts[pathParts.length - 2];
    const insideAssets = assetPart.endsWith('.assets');
    const isBlog = assetPart === '.assets';

    if (FileManager.getEditorType(selectedPath) && insideAssets) {
      pathParts.splice(pathParts.length - 2, 2, isBlog ? '' : assetPart.substring(0, assetPart.length - '.assets'.length));
      store.dispatch(setAssetsFolder({
        post: pathParts.join('/') + (isBlog ? '' : '.md')
      }))
    } else {
      store.dispatch(setAssetsFolder({}))
    }
  }
  return null;
}

export function convertModule(m: any) {
  const {
    clientLoader,
    clientAction,
    default: Component,
    HydrateFallback,
    ErrorBoundary,
    ...rest
  } = m;
  return {
    ...rest,
    loader: clientLoader,
    action: clientAction,
    Component,
    HydrateFallback,
    ErrorBoundary,
  };
}

export function convertModuleWithStore(m: any, store: StoreType) {
  const converted = convertModule(m);
  if (converted.loader) {
    const originalLoader = converted.loader;
    converted.loader = (args: any) => originalLoader({ ...args, context: { store } });
  }
  return converted;
}